import React from "react"

// cols is for determining how many grid columns there will be in the container. Default is

export const RowContainer = ({ children, cols = 2 }) => {
  return (
    <div
      className={`grid md:grid-flow-col gap-8 md:grid-cols-${cols} bg-white bg-opacity-75 p-8 w-full rounded`}
    >
      {children}
    </div>
  )
}
